<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path xmlns="http://www.w3.org/2000/svg" d="M0 8H8V0H0V8ZM2 2H6V6H2V2ZM0 18H8V10H0V18ZM2 12H6V16H2V12ZM10 0V8H18V0H10ZM16 6H12V2H16V6ZM10.01 10H12.01V12H10.01V10ZM12.01 12H14.01V14H12.01V12ZM10.01 14H12.01V16H10.01V14ZM14.01 14H16.01V16H14.01V14ZM16.01 16H18.01V18H16.01V16ZM12.01 16H14.01V18H12.01V16ZM14.01 10H16.01V12H14.01V10ZM16.01 12H18.01V14H16.01V12Z" :fill="color"/>
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: [Number, String], default: 20 },
    height: { type: [Number, String], default: 20 },
    color: { type: String, default: "#80B7FF" },
  },
};
</script>
